<template>
  <!-- <div class="sliders"> -->
  <vueper-slides
    class="no-shadow sliders"
    transition-speed="250"
    autoplay
    :arrows="false"
    :slide-ratio="1 / 1.2"
  >
    <vueper-slide :image="SliderUserValue"></vueper-slide>
    <vueper-slide :image="SliderPositive"></vueper-slide>
    <vueper-slide :image="SliderLove"></vueper-slide>
    <vueper-slide :image="SliderInnovation"></vueper-slide>
    <vueper-slide :image="SliderTrust"></vueper-slide>
    <template #bullet="{ active }">
      <i class="icon" :class="{ active: active }"></i>
    </template>
  </vueper-slides>
  <!-- </div> -->
</template>

<script>
import SliderUserValue from "@/assets/img/01_user_value.png";
import SliderLove from "@/assets/img/02_love.png";
import SliderPositive from "@/assets/img/03_positive.png";
import SliderInnovation from "@/assets/img/04_innovation.png";
import SliderTrust from "@/assets/img/05_trust.png";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
export default {
  name: "Sliders",
  components: { VueperSlides, VueperSlide },
  data() {
    return {
      breakpoints: {
        1200: {
          slideRatio: 1 / 5
        },
        900: {
          slideRatio: 1 / 3
        },
        600: {
          slideRatio: 1 / 2,
          arrows: false,
          bulletsOutside: true
        },
        // The order you list breakpoints does not matter, Vueper Slides will sort them for you.
        1100: {
          slideRatio: 1 / 4
        }
      },
      swiperOptions: {
        autoHeight: true,
        followFinger: false,
        allowTouchMove: false
        // Some Swiper option/callback...
      },
      SliderUserValue,
      SliderLove,
      SliderPositive,
      SliderInnovation,
      SliderTrust,
      viewportWidth: 0
    };
  },
  computed: {
    isShow() {
      return this.viewportWidth > 600;
    }
  },

  mounted() {
    this.viewportWidth = document.body.clientWidth;
    window.addEventListener("resize", this.getViewportWidth);
  },
  methods: {
    getViewportWidth() {
      this.viewportWidth = document.body.clientWidth;
    }
  }
};
</script>

<style scoped>
.icon {
  width: 12px;
  height: 12px;
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 50%;
  opacity: 0.5;
}
.icon.active {
  background: #fff;
}
.sliders {
  /* width: 100%; */
  width: 790.7px;
  /* height: 650.7px; */
  /* max-height: 650.7px; */
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.no-shadow >>> .vueperslides__bullets {
  top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Sliders.vue